module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business/bus-product-3-c2c7d8b098ab5832b7494e87bddad03e.jpg";